<script setup>

import MetricCard from '@/views/dashboard/components/MetricCard.vue'
import DonutMetricCard from '@/views/dashboard/components/DonutMetricCard.vue'

import { onMounted,ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useDashboardStore } from '@/stores/index.js'
import { useFilterStore } from '@/stores/index.js'
import emitter from '@/util/emitter.js'

defineOptions({
  name: 'DashboardOverview'
})

const emit = defineEmits(['showReportUpdateTime'])

const tooltips = [
  '使用 HCP360 个像用户总数',
  '通过 HCP360 个像查看 HCP 信息的客户总数',
  '平均每个用户通过 HCP360 个像查看客户数量',
  '用户使用 HCP360 个像的总次数',
  '平均每个用户使用 HCP360 个像的次数',
  '用户每次使用 HCP 个像的平均时长',
  '客户通过 HCP360 被用户查看的平均次数',
  '用户月均访问 HCP360 个像天数'
]

const loading = ref(true)
const dashboardStore = useDashboardStore()
const { dashboardData } = storeToRefs(dashboardStore)
const { postOverviewInfo } = dashboardStore
const filterStore = useFilterStore()
const {
  startDate,
  endDate,
  brandCode,
  familyCode,
  indicationCode,
  bu,
  subBu,
  rsd,
  rsm,
  dsm,
  mr
} = storeToRefs(filterStore)

const getDashboardData = () => {
  loading.value =true;
  const filters = {
    startDate: startDate.value,
    endDate: endDate.value,
    brandCode: brandCode.value,
    familyCode: familyCode.value,
    indicationCode: indicationCode.value,
    bu: bu.value,
    subBu: subBu.value,
    rsd: rsd.value,
    rsm: rsm.value,
    dsm: dsm.value,
    mr: mr.value
  }
  // console.log('filters', filters)
  postOverviewInfo(filters).then(data => {
    emit('showReportUpdateTime', data?.dataSyncTime)
     loading.value =false;
  }).catch(error => {
    // 请求异常
    loading.value =false;
  })

}

onMounted(() => {
  getDashboardData()
  emitter.on('filter-change', getDashboardData)
})
</script>

<template>
  <!-- 仅允许水平滚动，禁止垂直滚动 -->
  <!--  <el-scrollbar wrap-style="overflow-x: auto; overflow-y: hidden;">-->
  <div class="dashboard" v-loading="loading" >
    <div class="dashboard__card">
      <DonutMetricCard title="访问用户数" :tooltip="tooltips[0]" unit="访问用户数" :value="dashboardData.userCount || 0"
        :total="dashboardData.userArchitectureCount || 0" :growth="dashboardData.userCountRing || 0" />
    </div>
    <div class="dashboard__card">
      <MetricCard title="查看HCP人数" :tooltip="tooltips[1]" unit="人数" :value="dashboardData.hcpCount || 0"
        :growth="dashboardData.hcpCountRing || 0" />
      <MetricCard title="平均查看HCP人数" :tooltip="tooltips[2]" unit="人数" :value="dashboardData.avgHcpPerUser || 0"
        :growth="dashboardData.avgHcpPerUserRing || 0" />
    </div>
    <div class="dashboard__card">
      <MetricCard title="访问次数（查看HCP人次）" :tooltip="tooltips[3]" unit="人次" :value="dashboardData.visitHcpCount || 0"
        :growth="dashboardData.visitHcpCountRing || 0" />
      <MetricCard title="平均访问次数" :tooltip="tooltips[4]" unit="次数" :value="dashboardData.avgVisitsPerUser || 0"
        :growth="dashboardData.avgVisitsPerUserRing || 0" />
    </div>
    <div class="dashboard__card">
      <MetricCard title="平均访问时长（S）" :tooltip="tooltips[5]" unit="时长" :value="dashboardData.avgVisitsTime || 0"
        :growth="dashboardData.avgVisitsTimeRing || 0" />
      <MetricCard title="HCP平均被查看次数" :tooltip="tooltips[6]" unit="次数" :value="dashboardData.avgVisitsPerHcp || 0"
        :growth="dashboardData.avgVisitsPerHcpRing || 0" />
    </div>
    <div class="dashboard__card">
      <MetricCard title="月人均活跃天数" :tooltip="tooltips[7]" unit="天数" :value="dashboardData.avgActiveDaysPerUser || 0"
        :growth="dashboardData.avgActiveDaysPerUserRing || 0" />
    </div>
  </div>
  <!--  </el-scrollbar>-->
</template>

<style scoped lang="scss">
.dashboard {
  display: flex;
  flex-direction: row;
  height: 100%;

  &__card {
    flex: 1;
    flex-shrink: 0;
    height: 100%;
    //min-width: 300px;
  }

  &__card:not(:last-child) {
    border-right: 1px solid var(--color-border);
  }
}

// 禁止显示垂直滚动条
::v-deep(.el-scrollbar__bar.is-vertical) {
  display: none;
}
</style>
